import { Link, useLocation } from 'react-router-dom';
import { Button, Card, CardContent } from '@crestrewards/ui';
import { FileQuestion } from 'lucide-react';

import PageContainer from '../layout/PageContainer';

export default function NotFoundPage() {
  const location = useLocation();

  return (
    <PageContainer title="Page not found">
      <Card>
        <CardContent className="flex flex-col items-center gap-3 py-16 text-center">
          <FileQuestion className="h-8 w-8 text-subtle-foreground" aria-hidden="true" />
          <p className="text-meta font-medium text-foreground">
            Nothing lives at{' '}
            <code className="rounded bg-secondary px-1.5 py-0.5 font-mono text-label text-foreground">
              {location.pathname}
            </code>
          </p>
          <p className="max-w-sm text-meta text-muted-foreground">
            The link may be out of date, or the page has not been built yet. Head back to
            the dashboard and pick a section from the sidebar.
          </p>
          <Button asChild variant="outline" size="sm" className="mt-2">
            <Link to="/dashboard">Go to dashboard</Link>
          </Button>
        </CardContent>
      </Card>
    </PageContainer>
  );
}
